import { useAuth0 } from '@auth0/auth0-react';
import authClientOptions from 'utils/config/auth0.config';
import { useResetReduxAndWebStorage } from './useResetReduxAndWebStorage';

// log user out and reset user state
export const useRemoveAuth = (): {
  execRemoveAuth: () => void;
  isAuthenticated: boolean;
} => {
  const { logout, isAuthenticated } = useAuth0();
  const resetApp = useResetReduxAndWebStorage();

  const execRemoveAuth = async () => {
    await resetApp();
    //  clear redux
    logout({ logoutParams: { returnTo: authClientOptions.redirectURI } });
  };

  return {
    execRemoveAuth,
    isAuthenticated,
  };
};
